// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EcoStatsDataUsage } from './EcoStatsDataUsage';
import {
    EcoStatsDataUsageFromJSON,
    EcoStatsDataUsageFromJSONTyped,
    EcoStatsDataUsageToJSON,
    EcoStatsDataUsageToJSONTyped,
} from './EcoStatsDataUsage';

/**
 * 
 * @export
 * @interface EcoStatsData
 */
export interface EcoStatsData {
    /**
     * 
     */
    usage?: EcoStatsDataUsage;
    /**
     * 
     */
    messages?: number;
}

/**
 * Check if a given object implements the EcoStatsData interface.
 */
export function instanceOfEcoStatsData(value: object): value is EcoStatsData {
    return true;
}

export function EcoStatsDataFromJSON(json: any): EcoStatsData {
    return EcoStatsDataFromJSONTyped(json, false);
}

export function EcoStatsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EcoStatsData {
    if (json == null) {
        return json;
    }
    return {
        
        'usage': json['usage'] == null ? undefined : EcoStatsDataUsageFromJSON(json['usage']),
        'messages': json['messages'] == null ? undefined : json['messages'],
    };
}

export function EcoStatsDataToJSON(json: any): EcoStatsData {
    return EcoStatsDataToJSONTyped(json, false);
}

export function EcoStatsDataToJSONTyped(value?: EcoStatsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'usage': EcoStatsDataUsageToJSON(value['usage']),
        'messages': value['messages'],
    };
}

